import React, { useEffect, useRef, useState } from "react";
import "./Energy.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Energy = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1;

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Energy Management Systems",
      description:
        "Smart energy management solutions for optimizing consumption and reducing costs",
      whatsappMessage:
        "Hello, I'm interested in Energy Management Systems consultation.",
    },
    {
      id: 2,
      title: "Renewable Energy Integration",
      description:
        "Solutions for integrating solar, wind, and other renewable sources into existing grids",
      whatsappMessage:
        "Hello, I'm interested in Renewable Energy Integration consultation.",
    },
    {
      id: 3,
      title: "Grid Modernization",
      description:
        "Advanced grid management and modernization solutions for improved reliability",
      whatsappMessage:
        "Hello, I'm interested in Grid Modernization consultation.",
    },
    {
      id: 4,
      title: "Predictive Maintenance",
      description:
        "AI-powered predictive maintenance solutions for energy infrastructure",
      whatsappMessage:
        "Hello, I'm interested in Predictive Maintenance consultation.",
    },
    {
      id: 5,
      title: "Energy Trading Platforms",
      description:
        "Digital platforms for energy trading, procurement, and market operations",
      whatsappMessage:
        "Hello, I'm interested in Energy Trading Platforms consultation.",
    },
    {
      id: 6,
      title: "Energy Analytics",
      description:
        "Data-driven analytics for energy consumption, production, and optimization",
      whatsappMessage:
        "Hello, I'm interested in Energy Analytics consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="energy-sector-page">
      <Helmet>
        <title>
          Energy Technology Solutions | Digital Innovation for Energy Sector
        </title>
        <meta
          name="description"
          content="Explore our comprehensive energy technology solutions including energy management systems, renewable integration, grid modernization, and predictive maintenance."
        />
        <meta
          name="keywords"
          content="energy technology, energy management, renewable energy, grid modernization, predictive maintenance, energy trading, energy analytics, smart grid, energy solutions"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="energy-sector-hero">
        <div className="energy-sector-hero-content">
          <h1 className="energy-sector-hero-title">
            Powering the{" "}
            <span className="energy-sector-highlight">
              Future of Energy
            </span>
          </h1>
          <p className="energy-sector-hero-description">
            We develop innovative energy solutions that optimize operations, 
            enhance sustainability, and transform how energy is produced, 
            distributed, and consumed. From smart grid technologies to renewable 
            integration and energy management systems.
          </p>
          <div className="energy-sector-hero-buttons">
            <a href="/contact-us">
              <button className="energy-sector-btn energy-sector-btn-primary">
                Get Started
              </button>
            </a>
            <button className="energy-sector-btn energy-sector-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="energy-sector-hero-visual">
          <div className="energy-sector-animated-grid">
            <div className="energy-sector-grid-lines"></div>
            <div className="energy-sector-energy-flow"></div>
            <div className="energy-sector-renewable-icons">
              <div className="energy-sector-solar-panel"></div>
              <div className="energy-sector-wind-turbine"></div>
            </div>
          </div>
          <div className="energy-sector-orb energy-sector-orb-1"></div>
          <div className="energy-sector-orb energy-sector-orb-2"></div>
          <div className="energy-sector-orb energy-sector-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="energy-sector-services">
        <div className="energy-sector-services-header">
          <h2 className="energy-sector-section-title">
            Our Energy Technology Solutions
          </h2>
          <p className="energy-sector-section-subtitle">
            Innovative energy technology services designed to optimize operations, 
            enhance sustainability, and drive efficiency across the energy value chain.
          </p>
        </div>

        <div className="energy-sector-services-grid">
          {/* Energy Management Card */}
          <div className="energy-sector-service-card">
            <div className="energy-sector-service-icon">
              <div className="energy-sector-icon energy-sector-icon-management"></div>
            </div>
            <h3>Energy Management Systems</h3>
            <p>
              Smart energy management solutions for optimizing consumption, reducing costs, and improving efficiency.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-time Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Consumption Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Controls</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Cost Optimization</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">25%</div>
                <div className="stat-label">Cost Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Efficiency Gain</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Renewable Integration Card */}
          <div className="energy-sector-service-card">
            <div className="energy-sector-service-icon">
              <div className="energy-sector-icon energy-sector-icon-renewable"></div>
            </div>
            <h3>Renewable Energy Integration</h3>
            <p>
              Solutions for integrating solar, wind, and other renewable sources into existing energy grids.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Grid Integration</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Storage Solutions</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Forecasting Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Performance Monitoring</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Faster Integration</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99%</div>
                <div className="stat-label">Uptime</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Grid Modernization Card */}
          <div className="energy-sector-service-card">
            <div className="energy-sector-service-icon">
              <div className="energy-sector-icon energy-sector-icon-grid"></div>
            </div>
            <h3>Grid Modernization</h3>
            <p>
              Advanced grid management and modernization solutions for improved reliability and efficiency.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Smart Metering</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Distribution Automation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Outage Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Load Balancing</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">45%</div>
                <div className="stat-label">Fault Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">20%</div>
                <div className="stat-label">Efficiency Improvement</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Predictive Maintenance Card */}
          <div className="energy-sector-service-card">
            <div className="energy-sector-service-icon">
              <div className="energy-sector-icon energy-sector-icon-maintenance"></div>
            </div>
            <h3>Predictive Maintenance</h3>
            <p>
              AI-powered predictive maintenance solutions for energy infrastructure and equipment.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>AI-Powered Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Equipment Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Failure Prediction</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Maintenance Scheduling</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Downtime Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Maintenance Cost Saving</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Energy Trading Card */}
          <div className="energy-sector-service-card">
            <div className="energy-sector-service-icon">
              <div className="energy-sector-icon energy-sector-icon-trading"></div>
            </div>
            <h3>Energy Trading Platforms</h3>
            <p>
              Digital platforms for energy trading, procurement, and market operations.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Market Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Trading Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Risk Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Contract Management</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">Trading Efficiency</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Platform Reliability</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Energy Analytics Card */}
          <div className="energy-sector-service-card">
            <div className="energy-sector-service-icon">
              <div className="energy-sector-icon energy-sector-icon-analytics"></div>
            </div>
            <h3>Energy Analytics</h3>
            <p>
              Data-driven analytics for energy consumption, production, and operational optimization.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Consumption Patterns</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Production Optimization</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Forecasting Models</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Performance Benchmarking</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Better Decisions</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">25%</div>
                <div className="stat-label">Operational Savings</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* IoT Solutions Card */}
          <div className="energy-sector-service-card">
            <div className="energy-sector-service-icon">
              <div className="energy-sector-icon energy-sector-icon-iot"></div>
            </div>
            <h3>IoT Energy Solutions</h3>
            <p>
              Internet of Things solutions for connected energy assets and smart infrastructure.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Sensor Networks</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Remote Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Asset Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Alerts</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">10k+</div>
                <div className="stat-label">Devices Supported</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.5%</div>
                <div className="stat-label">Data Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Carbon Management Card */}
          <div className="energy-sector-service-card">
            <div className="energy-sector-service-icon">
              <div className="energy-sector-icon energy-sector-icon-carbon"></div>
            </div>
            <h3>Carbon Management</h3>
            <p>
              Solutions for tracking, managing, and reducing carbon emissions and environmental impact.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Emissions Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Carbon Accounting</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Sustainability Reporting</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compliance Management</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Emission Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">100%</div>
                <div className="stat-label">Regulatory Compliance</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="energy-sector-services-cta">
          <h3>Ready to transform your energy operations?</h3>
          <p>
            Schedule a free consultation with our energy technology experts
            to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="energy-sector-consultation-container">
              <button
                className="energy-sector-primary-btn energy-sector-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="energy-sector-modal-overlay">
                  <div className="energy-sector-modal-content">
                    <button
                      className="energy-sector-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="energy-sector-modal-title">
                      Energy Technology Consultation
                    </h2>
                    <p className="energy-sector-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="energy-sector-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`energy-sector-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="energy-sector-option-title">
                            {option.title}
                          </h3>
                          <p className="energy-sector-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`energy-sector-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="energy-sector-btn energy-sector-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="energy-sector-stats">
        <div className="energy-sector-stats-container">
          <div className="energy-sector-stat">
            <h3 className="energy-sector-stat-number" data-count="150">
              90
            </h3>
            <p className="energy-sector-stat-label">Energy Projects</p>
          </div>
          <div className="energy-sector-stat">
            <h3 className="energy-sector-stat-number" data-count="95">
              75
            </h3>
            <p className="energy-sector-stat-label">Client Satisfaction</p>
          </div>
          <div className="energy-sector-stat">
            <h3 className="energy-sector-stat-number" data-count="12">
              11
            </h3>
            <p className="energy-sector-stat-label">Years Experience</p>
          </div>
          <div className="energy-sector-stat">
            <h3 className="energy-sector-stat-number" data-count="25">
              30
            </h3>
            <p className="energy-sector-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="energy-sector-cta">
        <div className="energy-sector-cta-content">
          <h2>Ready to Transform Your Energy Operations?</h2>
          <p>
            Contact us today to discuss how our energy technology expertise
            can help your organization optimize operations and drive sustainability.
          </p>
          <a href="/contact-us">
            <button className="energy-sector-btn energy-sector-btn-primary energy-sector-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Energy
